import React, { useEffect, useState } from 'react';
import './FileUploadFieldWarranty.scss';
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader'
import HintWarranty from "../HintWarranty/HintWarranty";
import { useFormContext } from "react-hook-form";

const FileUploadFieldWarranty = ({ isVisible = [], changeState = null, id, hint = '', name, imageUpload} ) => {
    const [arrFiles, setArrFiles] = useState( [] );
    const [clear, setClear] = useState( true );
    const [imageUploadState] = useState(imageUpload);
    const [fullCont, setFullCont] = useState( false );

  var fileArr = []

  function fileSizeValidator(file) {
    const image_limit_size = 25;
    const video_limit_size = 200;
    if (file.meta.type === 'video/mp4' && file.meta.size > video_limit_size * 1024 * 1024) {
      return `Video limited to ${video_limit_size}MB`;
    }
    else if (file.meta.type === 'video/mp4' && fileArr.some(file_object => file_object.meta.type === 'video/mp4' && file_object.meta.status === 'done')) {
      return `Only one video file can be uploaded`;
    }
    else if (file.meta.type.startsWith("image/") && file.meta.size > image_limit_size * 1024 * 1024) {
      return `Image limited to ${image_limit_size}MB`;
    }
    return false;
  }

    const handleChangeStatus = ( { meta, file }, status, files ) => {
        if ( status === 'done' ) {
            handleFileRead( files ).then( result => {
                setArrFiles(result);
            })
        } else if ( status === 'removed' ) {
            let arrFiles = [];
            for ( let f of files ) {
                if ( f.file.name !== file.name ) {
                    arrFiles.push( f )
                }
            }
            handleFileRead( arrFiles ).then( result => {
                setArrFiles(result);
            })
        }

        fileArr = files;
        setTimeout(function() {
            files.length === 4 ? setFullCont( true ) : setFullCont( false );
        },0)
    }

    const showPopup = () => {
        const newArr = [...isVisible];
        newArr[id] = true;
        changeState( newArr )
        setClear( true );
    }
    const convertBase64 = ( files ) => {
        let arrBase64Arr = [];

         files.map( ( f ) => {
            const promise = new Promise( ( resolve, reject ) => {
                const fileReader = new FileReader();
                fileReader.readAsDataURL( f.file )
                fileReader.onload = () => {
                     resolve( fileReader.result );
                }
                fileReader.onerror = ( error ) => {
                     reject( error );
                }
            } );

              promise.then( result => {
                  arrBase64Arr.push({
                      fileB64: result,
                      meta: f.meta
                  })
             })
        } )

        return arrBase64Arr
    }

    const handleFileRead = async ( files ) => {
        return  await convertBase64( files );
    }

    const hidePopup = () => {
        const newArr = [...isVisible];
        newArr[id] = false;
        changeState( newArr );
    }

    const clearField = () => {
        setClear( false );
        setArrFiles( [] );
    }

    const { register, setValue } = useFormContext();

    useEffect( () => {
        register( name );
        setValue( name, arrFiles );
    }, [arrFiles, register, setValue, name, fullCont] );

    return (
        <div className="file-upload-field">
            <div className="file-upload-field__title">Upload photo/video {hint && <HintWarranty hint={hint}/>}</div>
            <div className="file-upload-field__btn" onClick={showPopup}>Browse</div>
            {arrFiles.length ? <div className="file-upload-field__total-file">{arrFiles.length} files added</div> : ''}
            {arrFiles.length ? <div className="file-upload-field__clear-field" onClick={clearField}/> : ''}
            <div className={`file-upload-field__popup ${isVisible[id] ? 'show' : ''}`}>
                <div className="file-upload-field__card">
                    <div className={`file-upload-field__close`} onClick={hidePopup}/>
                    {imageUploadState && <img className="file-upload-field__image" src='/modules/custom/milgard_service_request/assets/images/uploadImageRecallForm.png' alt=''/>}
                    {arrFiles.length ?
                        <div className={`file-upload-field__message`}>File uploaded! Please add more files or close
                            this window.</div> : ''}
                    {clear ? <Dropzone
                        validate={fileSizeValidator}
                        inputContent={'Drop files here'}
                        onChangeStatus={handleChangeStatus}
                        accept="image/png,image/gif,image/jpeg,video/mp4,application/pdf"
                        maxFiles={4}
                    /> : ''}
                    {fullCont ? <div className={`file-upload-field__quantity-limitation`}>Item limit is 4.</div> : ''}
                </div>
                <div className="file-upload-field__bg"/>
            </div>
        </div>
    )
};

FileUploadFieldWarranty.defaultProps = {
    imageUpload: false,
};

export default FileUploadFieldWarranty;
